module.exports = __webpack_public_path__ + "static/media/compensationIcon.09b51af9.svg";